import React from "react";
import "../styles/bio.scss";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link } from "react-router-dom";

export default function Bio() {
  return (
    <>
      <div className="page-container">
        <div className="bio-container">
          <img
            className="profile"
            src={process.env.PUBLIC_URL + "/dad_profile.jpg"}
            alt="profile"
          />
          <div>
            <div className="bio-header">
              <h3>Alan Robert Garry</h3>
              <a href="https://www.alanrobertgarry.com">
                www.alanrobertgarry.com
              </a>
              <a href="https://www.instagram.com/alanrobertgarry/">
                <InstagramIcon /> <div>alanrobertgarry</div>
              </a>
            </div>

            <div className="bio-content">
              <p className="bio-p1">
              I am an architect with a firm in NYC. I have been plein air painting for several years, although I started painting in college.
              </p>

              <p className="bio-p1">
              The focus of my painting is the builtscape:  what people have built in relation to each other.
              </p>

              <p>
              There is a geometry created by the multiple decisions: a beauty and movement in their assemblages, even in the most economically impoverished areas, as each builder had to deal with what their needs were and what had been constructed before them.
              </p>

              <p>
              I look for images with a geometry and color.
              </p>

              <p>
              Each city presented some starting point for my explorations.
              </p>

              <p>
                Each city presented some starting point for my explorations.
              </p>


              <p>
                <strong>Florence</strong>, <strong>Venice</strong>, <strong>Pienza</strong> 
                 and <strong>Toledo</strong> are cities I have visited, and the medieval portions of these cities reveal the geometries acquired as these cities developed.
            </p>
              <p>
                <strong>Monterrey</strong>, Mexico has very long blocks of initially identical buildings, which have been individually modified over time.
            </p>

              <p>
                <strong>Timbuktu</strong>, Mali, an ancient city,has a strong block geometry, but within each block a myriad of variations.
              </p>
              <p> 
                <strong>Rocinha</strong>, Brazil, a favela outside of Rio de Janeiro, has both chaotic
                residential areas and more organized commercial/industrial
                areas.
         </p>

              <p> 
                <strong>Delhi</strong> and <strong>Mumbai</strong>, India have both organized 
                industrial areas and areas of dense habitation.
              </p>

              <p> 
                <strong>Accra</strong>, Ghana, presented a dense, complex and colorful combination 
                of structures.
         </p>

              <p>
                I see these works not as a social statement, but as an
                acknowledgement that we are, in everything we do, part of the
                beauty of this world.
              </p>
            </div>

            <ul className="awards">
              <li><em>
                2021 Five Points Arts Center National Open Juried Exhibition,
                Torrington, CT
              </em>
              </li>
              <li>
                <em>
                  2021 Providence Art Club National Open Juried Exhibition,
                  Providence, RI
                </em>
              </li>
              <li>
                <em>
                  2021 Mamaroneck Artist’s Guild Small Works, Juried Exhibition,
                  Mamaroneck, NY
                </em>
              </li>
              <li>
                <em>
                  2021 Carriage Barn Arts Center Color+Art+Design, Juried
                  Exhibition, New Canaan, CT
                </em>
              </li>
              <li>
                <em>
                  2021 ArtsWestchester, Calling All Creatives, Curated Exhibition,
                  White Plains, NY
                </em>
              </li>

              <li>
                <em>
                2022 Cape Fears Studio National 2D Competition, Cape Fear, NC
                </em>
              </li>

              <li>
                <em>
                2022 Rice Gallery of Fine Art, City Life, National Juried Show, Overland Park, KS
                </em>
              </li>

              <li>
                <em>
                2022 d’Art Center, Scene, National Juried Exhibition, Norfolk, VA
                </em>
              </li>

              <li>
                <em>
                2022 Hudson Valley Art Association Annual Juried Exhibition, Lyme, CT
                </em>
              </li>

              <li>
                <em>
                2022 Ridgefield Guild of Artists 12th Annual Juried Show, Ridgefield, CT                </em>
              </li>

              <li>
                <em>
                2022 Five Points Arts Center National Open Juried Show for Small Pieces                </em>
              </li>

              <li>
                <em>
                2023 Viridian Gallery, 32nd International Juried Exhibition, NY, NY.
                </em>
              </li>
            </ul>

            <div className="footer">
              <div>
                Kossar + Garry Architects, LLP, Principal, 1980 - Present
              </div>
              <div>Rensselaer Polytechnic Institute, BS, BArch 1972</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
